(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-endless"]) return;
  try {
    
  // Global registry to track initialized banner block IDs
  window.initializedBannerIds = window.initializedBannerIds || new Set();

  class CollectionGridBanner extends HTMLElement {
    constructor() {
      super();
      this.desktopPosition = parseInt(this.dataset.position) || 0;
      this.mobilePosition = parseInt(this.dataset.mobilePosition) || this.desktopPosition;
      this.bannerContent = this.querySelector('li');
      this.blockId = this.dataset.blockId;

      // Check if this block ID has already been initialized
      if (window.initializedBannerIds.has(this.blockId)) {
        this.remove();
        return;
      }

      // Register this block ID as initialized
      window.initializedBannerIds.add(this.blockId);

      // Initial placement
      this.placeBanner();

      // Add resize listener
      this.resizeHandler = this.handleResize.bind(this);
      window.addEventListener('resize', this.resizeHandler);
    }

    // Get only actual product cards, excluding info blocks
    getProductCards() {
      const allItems = document.querySelectorAll('#product-grid li[data-item-number]');
      return Array.from(allItems).filter((item) => {
        // Exclude info blocks (they have w-100 class and contain productitem--info-block)
        return !item.classList.contains('w-100') || !item.querySelector('.productitem--info-block');
      });
    }

    placeBanner() {
      const products = this.getProductCards();
      if (!products.length || !this.bannerContent) return;

      // Determine current position based on screen width
      let position;
      let requiredProducts = 0;

      if (window.innerWidth < 600) {
        // Detect mobile column layout by checking the first product's classes
        const firstProduct = products[0];
        const isTwoColumnMobile = firstProduct && firstProduct.classList.contains('w-50');
        const productsPerRow = isTwoColumnMobile ? 2 : 1;

        // On mobile, position represents "after which row"
        // Setting 1 = after first row, setting 2 = after second row, etc.
        position = this.mobilePosition * productsPerRow;
        requiredProducts = position;

        // Check if we have enough products loaded to properly position the banner
        if (products.length < requiredProducts) {
          this.bannerContent.style.display = 'none';
          return;
        }
      } else {
        // On desktop, use the original position logic
        position = this.desktopPosition;
        requiredProducts = position;

        // Check if we have enough products loaded for desktop positioning
        if (products.length < requiredProducts) {
          this.bannerContent.style.display = 'none';
          return;
        }
      }

      // Show the banner since we have enough products
      this.bannerContent.style.display = '';

      // Get current banner location if it's already in the DOM
      let currentIndex = -1;
      if (this.bannerContent.parentNode) {
        const productBlocks = products;
        const parentIndex = productBlocks.findIndex((product) => product.nextElementSibling === this.bannerContent);
        if (parentIndex !== -1) currentIndex = parentIndex + 1;
      }

      // If position is valid and different from current position, move the banner
      if (position > 0 && position !== currentIndex) {
        // Find the target product (position is 1-based, so subtract 1 for array index)
        const targetProductIndex = position - 1;

        if (targetProductIndex >= 0 && targetProductIndex < products.length) {
          // On mobile with 2 columns, ensure we're inserting after complete rows
          if (window.innerWidth < 600) {
            const firstProduct = products[0];
            const isTwoColumnMobile = firstProduct && firstProduct.classList.contains('w-50');

            if (isTwoColumnMobile) {
              // For 2-column mobile, calculate the correct position based on row number
              // If mobilePosition is 4, we want after the 4th row (after product 8)
              const targetRow = this.mobilePosition;
              const lastProductOfTargetRow = Math.min(targetRow * 2, products.length);

              // Insert after the last product of the target row
              if (lastProductOfTargetRow > 0) {
                products[lastProductOfTargetRow - 1].parentNode.insertBefore(
                  this.bannerContent,
                  products[lastProductOfTargetRow - 1].nextSibling
                );
              }
            } else {
              // For 1-column mobile, insert after the target product
              products[targetProductIndex].parentNode.insertBefore(
                this.bannerContent,
                products[targetProductIndex].nextSibling
              );
            }
          } else {
            // Desktop: insert after the target product
            products[targetProductIndex].parentNode.insertBefore(
              this.bannerContent,
              products[targetProductIndex].nextSibling
            );
          }
        }
      } else {
      }
    }

    handleResize() {
      this.placeBanner();
    }

    disconnectedCallback() {
      // Clean up event listener when component is removed
      window.removeEventListener('resize', this.resizeHandler);
    }
  }
  customElements.define('grid-banner', CollectionGridBanner);

  class FeaturedCopyBlock extends HTMLElement {
    constructor() {
      super();
      this.blockIndex = parseInt(this.dataset.blockIndex) || 0;
      this.hasImage = this.dataset.hasImage === 'true';
      this.copyBlockContent = this.querySelector('li');
      this.desktopCols = this.getDesktopCols();

      // Initial placement
      this.placeCopyBlock();

      // Add resize listener
      this.resizeHandler = this.handleResize.bind(this);
      window.addEventListener('resize', this.resizeHandler);
    }

    getDesktopCols() {
      // Get desktop columns from the product grid data attribute
      const productGrid = document.querySelector('#product-grid');
      if (productGrid && productGrid.dataset.desktopCols) {
        return parseInt(productGrid.dataset.desktopCols) || 4;
      }
      // Try to parse from CSS grid class (e.g., wt-grid--lg-cols-3)
      if (productGrid) {
        const classes = productGrid.className;
        const match = classes.match(/wt-grid--lg-cols-(\d+)/);
        if (match) {
          return parseInt(match[1]) || 4;
        }
      }
      // Fallback: try to get from the first product's classes (for older flexbox layouts)
      const firstProduct = document.querySelector('#product-grid li[data-item-number]');
      if (firstProduct) {
        const classes = firstProduct.className;
        if (classes.includes('w-third')) return 3;
        if (classes.includes('w-25')) return 4;
        if (classes.includes('w-20')) return 5;
      }
      return 4;
    }

    getMobileCols() {
      // Try to parse from CSS grid class (e.g., wt-grid--cols-2)
      const productGrid = document.querySelector('#product-grid');
      if (productGrid) {
        const classes = productGrid.className;
        const match = classes.match(/wt-grid--cols-(\d+)/);
        if (match) {
          return parseInt(match[1]) || 2;
        }
      }
      // Fallback: try to get from the first product's classes (for older flexbox layouts)
      const firstProduct = document.querySelector('#product-grid li[data-item-number]');
      if (firstProduct) {
        const classes = firstProduct.className;
        if (classes.includes('w-50')) return 2;
        if (classes.includes('w-33')) return 3;
        if (classes.includes('w-25')) return 4;
      }
      return 2; // Default to 2 columns on mobile
    }

    isMobile() {
      // Check if we're on mobile (typically < 60em or 960px)
      return window.innerWidth < 960;
    }

    // Get only actual product cards, excluding info blocks and copy blocks
    getProductCards() {
      const allItems = document.querySelectorAll('#product-grid li[data-item-number]');
      return Array.from(allItems).filter((item) => {
        // Exclude info blocks and copy blocks
        const isW100 = item.classList.contains('w-100');
        const hasInfoBlock = item.querySelector('.productitem--info-block');
        const hasCopyBlock = item.querySelector('.featured-copy-block');
        const shouldInclude = !isW100 || (!hasInfoBlock && !hasCopyBlock);
        return shouldInclude;
      });
    }

    placeCopyBlock() {
      const products = this.getProductCards();

      if (!this.copyBlockContent) {
        return;
      }

      // For block index 0, we can show it even without products
      // For other blocks, we need products to position correctly
      if (this.blockIndex > 0 && !products.length) {
        this.copyBlockContent.style.display = 'none';
        return;
      }

      // Calculate position:
      // First block (index 0) goes at position 0 (before first product)
      // Second block (index 1) goes after 2 rows
      // Third block (index 2) goes after 4 rows, etc.
      const isMobileView = this.isMobile();
      const productsPerRow = isMobileView ? this.getMobileCols() : this.desktopCols;
      const rowsPerBlock = 2; // Every two rows
      let position;

      if (this.blockIndex === 0) {
        // First block goes at the start (position 0)
        position = 0;
      } else {
        // Other blocks go after every 2 rows
        // Formula: blockIndex * 2 * productsPerRow
        // On mobile: blockIndex * 2 * 2 = blockIndex * 4 products (2 rows of 2)
        // On desktop: blockIndex * 2 * desktopCols
        position = this.blockIndex * rowsPerBlock * productsPerRow;
      }

      // Show the copy block (both the wrapper and the content)
      this.style.display = ''; // Show the featured-copy-block wrapper
      this.copyBlockContent.style.display = ''; // Show the li content

      // Get current location if it's already in the DOM
      let currentIndex = -1;
      if (this.copyBlockContent.parentNode) {
        const productBlocks = this.getProductCards();
        const parentIndex = productBlocks.findIndex((product) => product.nextElementSibling === this.copyBlockContent);
        if (parentIndex !== -1) currentIndex = parentIndex + 1;
        // Check if it's at the start (before first product)
        if (productBlocks.length > 0 && productBlocks[0].previousElementSibling === this.copyBlockContent) {
          currentIndex = 0;
        }
      }

      // Insert the block at the correct position
      const productGrid = document.querySelector('#product-grid');
      if (!productGrid) {
        return;
      }

      // If we don't have enough products to reach the calculated position,
      // place the copy block at the end instead of hiding it
      let actualPosition = position;
      if (position > 0 && products.length < position) {
        // Place at the end (after the last product)
        actualPosition = products.length;
      }

      if (actualPosition === 0) {
        // Insert at the start of the product grid (before first product)
        if (currentIndex !== 0) {
          if (products.length > 0) {
            productGrid.insertBefore(this.copyBlockContent, products[0]);
          } else {
            // No products yet, append to grid
            productGrid.appendChild(this.copyBlockContent);
          }
        }
      } else if (actualPosition !== currentIndex) {
        // Insert after the target product
        const targetProductIndex = actualPosition - 1;

        if (targetProductIndex >= 0 && targetProductIndex < products.length) {
          const targetProduct = products[targetProductIndex];
          productGrid.insertBefore(this.copyBlockContent, targetProduct.nextSibling);
        } else if (products.length > 0) {
          // If position is beyond available products, place at the end
          const lastProduct = products[products.length - 1];
          productGrid.insertBefore(this.copyBlockContent, lastProduct.nextSibling);
        } else {
          // No products, append to grid
          productGrid.appendChild(this.copyBlockContent);
        }
      }
    }

    handleResize() {
      this.desktopCols = this.getDesktopCols();
      this.placeCopyBlock();
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.resizeHandler);
    }
  }
  customElements.define('featured-copy-block', FeaturedCopyBlock);

  class InfiniteScroll extends HTMLElement {
    constructor() {
      super();

      this.productsGrid = document.querySelector('#product-grid');
      this.loading = this.querySelector('.loading-overlay');
      this.seo = document.querySelector('#section__collection-seo');
      this.storageKey = `collection-scroll-${window.location.pathname}`;
      this.currentPage = 1;
      this.isRestoring = false; // Flag to prevent interference during restoration
      this.restorationCompleted = false; // Flag to prevent multiple restoration attempts
      window.addEventListener('pageshow', (event) => {
        if (event.persisted) {
          sessionStorage.removeItem(`Last Page Position URL: ${this.storageKey}`);
        } else {
        }
      });

      this.querySelector('a').remove();

      if (!this.productsGrid) return;

      if (this.seo) this.seo.classList.add('o-0', 'h-0', 'pointer-none', 'overflow-hidden');

      // Only set up scroll tracking once
      InfiniteScroll.setupGlobalScrollTracking(this.storageKey);

      // Check if we need to restore state - only once at page load
      this.checkAndRestoreScrollState();

      // Set up intersection observer for normal infinite scroll
      const handleIntersection = (entries, observer) => {
        // Don't trigger infinite scroll if we're in the middle of restoration
        if (this.isRestoring || this.restorationCompleted === false || !entries[0].isIntersecting) {
          return;
        }
        this.loadNextPage();
      };

      this.observer = new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 500px 0px' });
      this.observer.observe(this);
    }

    // Static method to ensure scroll tracking is only set up once globally
    static setupGlobalScrollTracking(storageKey) {
      // Use a global window flag to ensure this only runs once per page
      if (window.infiniteScrollTrackingInitialized) {
        return;
      }

      window.infiniteScrollTrackingInitialized = true;

      // Create a consistent storage key for this collection page
      const globalStorageKey = `collection-scroll-${window.location.pathname}`;

      // Track when clicking on product links with line item numbers
      document.addEventListener('click', (e) => {
        // Don't save state if the quick-add button was clicked
        if (e.target.closest('.quick-add-btn')) {
          return;
        }

        const productLink = e.target.closest('.collection-products li a[href*="/products/"]');
        if (productLink) {
          // Find the parent <li> element with data-item-number
          const listItem = productLink.closest('li[data-item-number]');

          if (listItem) {
            const itemNumber = parseInt(listItem.getAttribute('data-item-number'));
            const infiniteScrollElement = document.querySelector('infinite-scroll');

            if (infiniteScrollElement && infiniteScrollElement.dataset.url) {
              const infiniteScrollUrl = infiniteScrollElement.dataset.url;
              const queryString = infiniteScrollUrl.split('?')[1] || '';
              const urlParams = new URLSearchParams(queryString);
              let currentPage;
              if (infiniteScrollElement.dataset.lastPage) {
                currentPage = parseInt(urlParams.get('page') || '1');
              } else {
                const page = parseInt(urlParams.get('page') || '1');
                currentPage = page - 1;
              } // Save state for any item clicked (not just page > 1)
              const productTitle = productLink.querySelector('.product-info .lh-title, h3, .product-title');
              const productTitleText = productTitle ? productTitle.textContent.trim() : '';

              // Use the consistent global storage key
              sessionStorage.setItem(
                `Last Page Position URL: ${globalStorageKey}`,
                JSON.stringify({
                  clickedItemNumber: itemNumber,
                  collectionRelatedPathname: window.location.pathname,
                  atProduct: productTitleText,
                  productLink: productLink.href,
                  infiniteScrollPage: currentPage,
                  scrollPosition: window.pageYOffset,
                  timestamp: Date.now(),
                })
              );
            }
          }
        }
      });
    }

    // This only runs once when the page loads
    checkAndRestoreScrollState() {
      const savedState = sessionStorage.getItem(`Last Page Position URL: ${this.storageKey}`);

      // Use a global flag to prevent multiple restoration attempts across instances
      if (window.infiniteScrollRestorationStarted) {
        this.restorationCompleted = true;
        return;
      }

      // Prevent multiple restoration attempts
      if (this.restorationCompleted !== false) {
        return;
      }

      if (!savedState) {
        this.restorationCompleted = true;
        return;
      }

      try {
        const state = JSON.parse(savedState);
        const { infiniteScrollPage, scrollPosition, clickedItemNumber, timestamp } = state;

        // Check if the saved state is recent (within 5 minutes)
        const fiveMinutesInMs = 5 * 60 * 1000;
        const isRecent = Date.now() - timestamp < fiveMinutesInMs;

        if (!isRecent) {
          // Clean up old state
          sessionStorage.removeItem(`Last Page Position URL: ${this.storageKey}`);
          this.restorationCompleted = true;
          return;
        }

        // Mark that restoration has started globally
        window.infiniteScrollRestorationStarted = true;

        // Start the restoration process
        this.isRestoring = true;
        this.loadPagesToTarget(infiniteScrollPage, clickedItemNumber, scrollPosition);
      } catch (error) {
        console.error('Error parsing saved scroll state:', error);
        sessionStorage.removeItem(`Last Page Position URL: ${this.storageKey}`);
        this.restorationCompleted = true;
      }
    }

    async loadPagesToTarget(targetPage, targetItemNumber, fallbackScrollPosition) {
      // Show loading indicator
      this.loading.classList.remove('dn');

      try {
        // Only proceed if we have pages to load
        if (targetPage && targetPage > 1) {
          // Load pages sequentially from page 2 to target page
          for (let page = 2; page <= targetPage; page++) {
            // Check if we still have a URL to load
            if (!this.dataset.url) {
              break;
            }

            // Load the next page
            const response = await fetch(this.dataset.url);
            const text = await response.text();
            const html = document.createElement('div');
            html.innerHTML = text;

            const products = html.querySelector('#product-grid');
            const infinite = html.querySelector('infinite-scroll');

            if (products && products.innerHTML.trim().length) {
              // Get the current number of items to continue numbering from
              const existingItems = this.productsGrid.querySelectorAll('li[data-item-number]');
              const lastItemNumber =
                existingItems.length > 0
                  ? parseInt(existingItems[existingItems.length - 1].getAttribute('data-item-number'))
                  : 0;

              // Update line item numbers for new items before adding to DOM
              const newItems = products.querySelectorAll('li[data-item-number]');
              newItems.forEach((item, index) => {
                const newItemNumber = lastItemNumber + index + 1;
                item.setAttribute('data-item-number', newItemNumber);
              });

              // Add the updated items to the grid (info blocks already removed from AJAX response)
              this.productsGrid.insertAdjacentHTML('beforeend', products.innerHTML);
              this.currentPage = page;

              // Reinitialize grid banners after new products are added
              this.reinitializeGridBanners();
            }

            // Update the URL for the next page
            if (infinite) {
              this.dataset.url = infinite.dataset.url;
              this.dataset.currentPage = page;
            } else {
              // No more pages available
              this.dataset.lastPage = true;
              if (this.seo) {
                this.seo.classList.remove('o-0', 'h-0', 'pointer-none', 'overflow-hidden');
              }
              break;
            }

            // Small delay to prevent overwhelming the server
            await new Promise((resolve) => setTimeout(resolve, 100));
          }
        } else {
        }

        // Hide loading indicator
        this.loading.classList.add('dn');

        // NOW scroll to the target item (only after all pages are loaded)
        setTimeout(() => {
          this.scrollToTargetItem(targetItemNumber, fallbackScrollPosition);

          // Clean up the saved state after successful restoration
          sessionStorage.removeItem(`Last Page Position URL: ${this.storageKey}`);

          // Mark restoration as complete and reset global flag
          this.isRestoring = false;
          this.restorationCompleted = true;
          window.infiniteScrollRestorationStarted = false; // Reset for potential future use
        }, 300); // Increased timeout to ensure DOM is fully updated
      } catch (error) {
        console.error('Error loading pages for scroll restoration:', error);
        this.loading.classList.add('dn');
        this.isRestoring = false;
        this.restorationCompleted = true;
        window.infiniteScrollRestorationStarted = false; // Reset on error too

        // Clean up on error
        sessionStorage.removeItem(`Last Page Position URL: ${this.storageKey}`);
      }
    }

    // Scroll to the specific line item that was clicked
    scrollToTargetItem(targetItemNumber, fallbackScrollPosition) {
      const currentItems = this.productsGrid.querySelectorAll('li[data-item-number]');

      if (targetItemNumber) {
        // Find the target item by data-item-number
        const targetItem = this.productsGrid.querySelector(`li[data-item-number="${targetItemNumber}"]`);

        if (targetItem) {
          // Scroll to the target item with some offset
          const offsetTop = targetItem.offsetTop - 100; // 100px offset from top

          window.scrollTo({
            top: offsetTop,
            behavior: 'smooth',
          });

          setTimeout(() => {
            targetItem.style.transform = '';
            targetItem.style.boxShadow = '';
          }, 1000);

          sessionStorage.removeItem(`Last Page Position URL: ${this.storageKey}`);
          return;
        } else {
        }
      }

      // Fallback to scroll position if item not found
      if (fallbackScrollPosition) {
        window.scrollTo({
          top: fallbackScrollPosition,
          behavior: 'smooth',
        });
      } else {
      }
    }

    loadNextPage() {
      this.loading.classList.remove('dn');
      this.currentPage++;

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;

          const products = html.querySelector('#product-grid');
          const infinite = html.querySelector('infinite-scroll');

          if (products && products.innerHTML.trim().length) {
            // Get the current number of items to continue numbering from
            const existingItems = this.productsGrid.querySelectorAll('li[data-item-number]');
            const lastItemNumber =
              existingItems.length > 0
                ? parseInt(existingItems[existingItems.length - 1].getAttribute('data-item-number'))
                : 0;

            // Update line item numbers for new items before adding to DOM
            const newItems = products.querySelectorAll('li[data-item-number]');
            newItems.forEach((item, index) => {
              const newItemNumber = lastItemNumber + index + 1;
              item.setAttribute('data-item-number', newItemNumber);
            });

            // Add the updated items to the grid (info blocks already removed from AJAX response)
            this.productsGrid.insertAdjacentHTML('beforeend', products.innerHTML);

            // Reinitialize grid banners after new products are added
            this.reinitializeGridBanners();
          }

          if (infinite) {
            this.dataset.url = infinite.dataset.url;
            this.dataset.currentPage = this.currentPage;
          } else {
            this.dataset.lastPage = true;
            this.observer.unobserve(this);
            if (this.seo) this.seo.classList.remove('o-0', 'h-0', 'pointer-none', 'overflow-hidden');
          }
          this.loading.classList.add('dn');
        })
        .catch((e) => {
          this.loading.classList.add('dn');
          console.error(e);
        });
    }

    reinitializeGridBanners() {
      // Find all existing grid-banner elements and reposition them based on new product count
      const gridBanners = document.querySelectorAll('grid-banner');
      gridBanners.forEach((banner) => {
        if (banner.placeBanner) {
          banner.placeBanner();
        }
      });

      // Also reinitialize copy blocks
      const copyBlocks = document.querySelectorAll('featured-copy-block');
      copyBlocks.forEach((block) => {
        if (block.placeCopyBlock) {
          block.placeCopyBlock();
        }
      });
    }
  }
  customElements.define('infinite-scroll', InfiniteScroll);

  document.addEventListener('DOMContentLoaded', function () {
    const url = window.location.href;
    if (url.includes('/collections')) {
      const urlParams = new URLSearchParams(window.location.search);
      const currentPage = urlParams.get('page');

      if (currentPage && parseInt(currentPage) > 1) {
        const newUrl = window.location.href.split('?')[0];
        window.location.href = newUrl;
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-season"] && !Shopify.designMode) return;
  try {
    
  class InstantPagesLoad extends HTMLElement {
    constructor() {
      super();

      // Cache DOM elements
      this.collectionsGrid = document.querySelector('#collection-grid');
      this.loading = this.querySelector('.loading-overlay');
      this.seo = document.querySelector('#section__collection-seo');

      // Initialize state
      this.seasonInUrl = this.extractSeasonFromUrl();

      // Remove the default link
      const defaultLink = this.querySelector('a');
      if (defaultLink) defaultLink.remove();

      if (!this.collectionsGrid) return;

      if (this.seo) {
        this.seo.classList.add('o-0', 'h-0', 'pointer-none', 'overflow-hidden');
      }

      this.loadAllPages(this.dataset.url);
    }

    extractSeasonFromUrl() {
      const url = window.location.href.toLowerCase();
      const hash = window.location.hash.replace('#', '');
      const seasons = ['spring', 'summer', 'fall', 'winter', 'holiday'];

      // Check hash first, then URL path
      if (hash && seasons.includes(hash)) {
        return hash;
      }

      return seasons.find((season) => url.includes(season)) || '';
    }

    async loadAllPages(url) {
      if (!url) return;

      this.loading.classList.remove('dn');

      try {
        while (url) {
          const response = await fetch(url);
          const text = await response.text();
          const html = document.createElement('div');
          html.innerHTML = text;

          const collections = html.querySelector('#collection-grid');
          const nextPage = html.querySelector('instant-pages-load');

          if (collections) {
            this.appendNewCollections(collections);
          }

          url = nextPage ? nextPage.dataset.url : null;
        }
      } catch (error) {
        console.error('Error loading pages:', error);
      } finally {
        this.loading.classList.add('dn');
        if (this.seo) {
          this.seo.classList.remove('o-0', 'h-0', 'pointer-none', 'overflow-hidden');
        }
        // Only initialize filtering once globally
        InstantPagesLoad.initializeGlobalFiltering();
      }
    }

    appendNewCollections(collections) {
      collections.querySelectorAll('.collection__item').forEach((newItem) => {
        const existingItem = this.collectionsGrid.querySelector(`[data-id="${newItem.dataset.id}"]`);
        if (!existingItem) {
          this.collectionsGrid.appendChild(newItem.cloneNode(true));
        }
      });
    }

    // Static method to ensure filtering is only initialized once
    static initializeGlobalFiltering() {
      // Use a static flag to ensure this only runs once
      if (InstantPagesLoad.filteringInitialized) return;

      InstantPagesLoad.filteringInitialized = true;

      const seasonInUrl = InstantPagesLoad.extractSeasonFromUrl();
      console.log('Initializing season filtering for:', seasonInUrl);

      InstantPagesLoad.addSeasonFilterListeners();
      InstantPagesLoad.preSelectSeason(seasonInUrl);
    }

    static extractSeasonFromUrl() {
      const url = window.location.href.toLowerCase();
      const hash = window.location.hash.replace('#', '');
      const seasons = ['spring', 'summer', 'fall', 'winter', 'holiday'];

      // Check hash first, then URL path
      if (hash && seasons.includes(hash)) {
        return hash;
      }

      return seasons.find((season) => url.includes(season)) || '';
    }

    static addSeasonFilterListeners() {
      const seasonFilterTabs = document.querySelectorAll('.collection-seasons__container .season.tab a');

      seasonFilterTabs.forEach((filter) => {
        filter.addEventListener('click', (e) => InstantPagesLoad.handleSeasonClick(e, filter));
      });
    }

    static handleSeasonClick(e, filter) {
      e.preventDefault();

      // Prevent rapid clicking
      if (filter.dataset.processing) return;
      filter.dataset.processing = 'true';

      setTimeout(() => {
        delete filter.dataset.processing;
      }, 300);

      // Don't process if already active
      if (filter.parentElement.classList.contains('active')) {
        return;
      }

      InstantPagesLoad.updateActiveTab(filter);
      InstantPagesLoad.applySeasonFilter(filter.getAttribute('data-season'));
      InstantPagesLoad.updateUrlHash(filter.getAttribute('data-season'));
    }

    static updateActiveTab(activeFilter) {
      const seasonFilterTabs = document.querySelectorAll('.collection-seasons__container .season.tab');

      seasonFilterTabs.forEach((tab) => {
        tab.classList.remove('active');
      });

      activeFilter.parentElement.classList.add('active');
    }

    static applySeasonFilter(selectedSeason) {
      const collections = document.querySelectorAll('.collection__item');

      collections.forEach((collection) => {
        const itemSeasons = collection.getAttribute('data-item-season');
        if (!itemSeasons) return;

        const seasonList = itemSeasons.toLowerCase().split(' - ');
        const shouldShow = selectedSeason === 'all' || seasonList.includes(selectedSeason);

        if (shouldShow) {
          collection.classList.remove('dn');
          collection.classList.add('db');
        } else {
          collection.classList.remove('db');
          collection.classList.add('dn');
        }
      });

      // Trigger a custom event for other components that might need to know
      document.dispatchEvent(
        new CustomEvent('seasonFilterChanged', {
          detail: { season: selectedSeason },
        })
      );
    }

    static updateUrlHash(season) {
      if (season === 'all') {
        // Remove hash for 'all'
        if (window.location.hash) {
          history.replaceState(null, null, window.location.pathname + window.location.search);
        }
      } else {
        // Update hash for specific season
        history.replaceState(null, null, `${window.location.pathname}${window.location.search}#${season}`);
      }
    }

    static preSelectSeason(seasonInUrl) {
      if (!seasonInUrl) return;

      const seasonFilterTabs = document.querySelectorAll('.collection-seasons__container .season.tab a');
      const targetFilter = Array.from(seasonFilterTabs).find(
        (filter) => filter.getAttribute('data-season') === seasonInUrl
      );

      if (targetFilter) {
        // Use a small delay to ensure DOM is ready
        setTimeout(() => {
          targetFilter.click();
        }, 100);
      }
    }
  }
  customElements.define('instant-pages-load', InstantPagesLoad);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-stock-photos"]) return;
  try {
    
  class InfiniteScroll extends HTMLElement {
    constructor() {
      super();

      this.productsGrid = document.querySelector('#product-grid');
      this.loading = this.querySelector('.loading-overlay');
      this.seo = document.querySelector('#section__collection-seo');
      this.storageKey = `collection-scroll-${window.location.pathname}`;
      this.currentPage = 1;
      this.isRestoring = false; // Flag to prevent interference during restoration
      this.restorationCompleted = false; // Flag to prevent multiple restoration attempts
      window.addEventListener('pageshow', (event) => {
        if (event.persisted) {
          console.log('Page restored from bfcache');
          sessionStorage.removeItem(`Last Page Position URL: ${this.storageKey}`);
        } else {
          console.log('Normal load');
        }
      });

      this.querySelector('a').remove();

      if (!this.productsGrid) return;

      if (this.seo) this.seo.classList.add('o-0', 'h-0', 'pointer-none', 'overflow-hidden');

      // Only set up scroll tracking once
      InfiniteScroll.setupGlobalScrollTracking(this.storageKey);

      // Check if we need to restore state - only once at page load
      this.checkAndRestoreScrollState();

      // Set up intersection observer for normal infinite scroll
      const handleIntersection = (entries, observer) => {
        // Don't trigger infinite scroll if we're in the middle of restoration
        if (this.isRestoring || this.restorationCompleted === false || !entries[0].isIntersecting) {
          return;
        }
        this.loadNextPage();
      };

      this.observer = new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 500px 0px' });
      this.observer.observe(this);
    }

    // Static method to ensure scroll tracking is only set up once globally
    static setupGlobalScrollTracking(storageKey) {
      // Use a global window flag to ensure this only runs once per page
      if (window.infiniteScrollTrackingInitialized) {
        console.log('📋 Scroll tracking already initialized, skipping setup...');
        return;
      }

      console.log('🚀 Initializing scroll tracking for the first time...');
      window.infiniteScrollTrackingInitialized = true;

      // Create a consistent storage key for this collection page
      const globalStorageKey = `collection-scroll-${window.location.pathname}`;

      // Track when clicking on product links with line item numbers
      document.addEventListener('click', (e) => {
        if (e.target.closest('.quick-add-btn')) {
          return;
        }
        const productLink = e.target.closest('#product-grid li a[href*="/products/"]');
        if (productLink) {
          // Find the parent <li> element with data-item-number
          const listItem = productLink.closest('li[data-item-number]');

          if (listItem) {
            const itemNumber = parseInt(listItem.getAttribute('data-item-number'));
            const infiniteScrollElement = document.querySelector('infinite-scroll');

            if (infiniteScrollElement && infiniteScrollElement.dataset.url) {
              const infiniteScrollUrl = infiniteScrollElement.dataset.url;
              const queryString = infiniteScrollUrl.split('?')[1] || '';
              const urlParams = new URLSearchParams(queryString);
              console.log(infiniteScrollElement);
              let currentPage;
              if (infiniteScrollElement.dataset.lastPage) {
                currentPage = parseInt(urlParams.get('page') || '1');
              } else {
                const page = parseInt(urlParams.get('page') || '1');
                currentPage = page - 1;
              } // Save state for any item clicked (not just page > 1)
              const productTitle = productLink.querySelector('.product-info .lh-title, h3, .product-title');
              const productTitleText = productTitle ? productTitle.textContent.trim() : '';

              console.log(
                'Saving state on product click - Item:',
                itemNumber,
                'Page:',
                currentPage,
                'Scroll:',
                window.pageYOffset
              );

              // Use the consistent global storage key
              sessionStorage.setItem(
                `Last Page Position URL: ${globalStorageKey}`,
                JSON.stringify({
                  clickedItemNumber: itemNumber,
                  collectionRelatedPathname: window.location.pathname,
                  atProduct: productTitleText,
                  productLink: productLink.href,
                  infiniteScrollPage: currentPage,
                  scrollPosition: window.pageYOffset,
                  timestamp: Date.now(),
                })
              );
            }
          }
        }
      });
    }

    // This only runs once when the page loads
    checkAndRestoreScrollState() {
      const savedState = sessionStorage.getItem(`Last Page Position URL: ${this.storageKey}`);

      // Use a global flag to prevent multiple restoration attempts across instances
      if (window.infiniteScrollRestorationStarted) {
        console.log('🚫 Restoration already started by another instance, skipping...');
        this.restorationCompleted = true;
        return;
      }

      // Prevent multiple restoration attempts
      if (this.restorationCompleted !== false) {
        console.log('🚫 Restoration already completed or in progress, skipping...');
        return;
      }

      if (!savedState) {
        console.log('📭 No saved state found, marking restoration as completed');
        this.restorationCompleted = true;
        return;
      }

      try {
        const state = JSON.parse(savedState);
        const { infiniteScrollPage, scrollPosition, clickedItemNumber, timestamp } = state;

        // Check if the saved state is recent (within 5 minutes)
        const fiveMinutesInMs = 5 * 60 * 1000;
        const isRecent = Date.now() - timestamp < fiveMinutesInMs;

        if (!isRecent) {
          // Clean up old state
          sessionStorage.removeItem(`Last Page Position URL: ${this.storageKey}`);
          console.log('🗑️ Removed expired state, marking restoration as completed');
          this.restorationCompleted = true;
          return;
        }

        console.log(
          `🎯 Starting restoration: Item ${clickedItemNumber}, Page ${infiniteScrollPage}, Position ${scrollPosition}`
        );

        // Mark that restoration has started globally
        window.infiniteScrollRestorationStarted = true;

        // Start the restoration process
        this.isRestoring = true;
        this.loadPagesToTarget(infiniteScrollPage, clickedItemNumber, scrollPosition);
      } catch (error) {
        console.error('Error parsing saved scroll state:', error);
        sessionStorage.removeItem(`Last Page Position URL: ${this.storageKey}`);
        this.restorationCompleted = true;
      }
    }

    async loadPagesToTarget(targetPage, targetItemNumber, fallbackScrollPosition) {
      // Show loading indicator
      this.loading.classList.remove('dn');

      try {
        // Only proceed if we have pages to load
        if (targetPage && targetPage > 1) {
          console.log(`Need to load ${targetPage} pages before scrolling to item ${targetItemNumber}`);

          // Load pages sequentially from page 2 to target page
          for (let page = 2; page <= targetPage; page++) {
            console.log(`Loading page ${page} of ${targetPage}...`);

            // Check if we still have a URL to load
            if (!this.dataset.url) {
              console.log('No more pages to load');
              break;
            }

            // Load the next page
            const response = await fetch(this.dataset.url);
            const text = await response.text();
            const html = document.createElement('div');
            html.innerHTML = text;

            const products = html.querySelector('#product-grid');
            const infinite = html.querySelector('infinite-scroll');

            if (products && products.innerHTML.trim().length) {
              // Get the current number of items to continue numbering from
              const existingItems = this.productsGrid.querySelectorAll('li[data-item-number]');
              const lastItemNumber =
                existingItems.length > 0
                  ? parseInt(existingItems[existingItems.length - 1].getAttribute('data-item-number'))
                  : 0;

              // Update line item numbers for new items before adding to DOM
              const newItems = products.querySelectorAll('li[data-item-number]');
              newItems.forEach((item, index) => {
                const newItemNumber = lastItemNumber + index + 1;
                item.setAttribute('data-item-number', newItemNumber);
              });

              // Add the updated items to the grid
              this.productsGrid.insertAdjacentHTML('beforeend', products.innerHTML);
              this.currentPage = page;

              console.log(
                `✅ Page ${page} loaded successfully. Grid now has ${
                  this.productsGrid.querySelectorAll('li[data-item-number]').length
                } items`
              );
            }

            // Update the URL for the next page
            if (infinite) {
              this.dataset.url = infinite.dataset.url;
              this.dataset.currentPage = page;
            } else {
              // No more pages available
              this.dataset.lastPage = true;
              if (this.seo) {
                this.seo.classList.remove('o-0', 'h-0', 'pointer-none', 'overflow-hidden');
              }
              console.log('No more pages available');
              break;
            }

            // Small delay to prevent overwhelming the server
            await new Promise((resolve) => setTimeout(resolve, 100));
          }

          console.log(`🎯 All pages loaded! Now attempting to scroll to item ${targetItemNumber}`);
        } else {
          console.log('No additional pages needed, target item should already be available');
        }

        // Hide loading indicator
        this.loading.classList.add('dn');

        // NOW scroll to the target item (only after all pages are loaded)
        setTimeout(() => {
          console.log('🔍 Searching for target item in loaded content...');
          this.scrollToTargetItem(targetItemNumber, fallbackScrollPosition);

          // Clean up the saved state after successful restoration
          sessionStorage.removeItem(`Last Page Position URL: ${this.storageKey}`);

          // Mark restoration as complete and reset global flag
          this.isRestoring = false;
          this.restorationCompleted = true;
          window.infiniteScrollRestorationStarted = false; // Reset for potential future use
          console.log('✅ Restoration process completed and marked as done');
        }, 300); // Increased timeout to ensure DOM is fully updated
      } catch (error) {
        console.error('Error loading pages for scroll restoration:', error);
        this.loading.classList.add('dn');
        this.isRestoring = false;
        this.restorationCompleted = true;
        window.infiniteScrollRestorationStarted = false; // Reset on error too

        // Clean up on error
        sessionStorage.removeItem(`Last Page Position URL: ${this.storageKey}`);
      }
    }

    // Scroll to the specific line item that was clicked
    scrollToTargetItem(targetItemNumber, fallbackScrollPosition) {
      // Debug: Log current state
      const currentItems = this.productsGrid.querySelectorAll('li[data-item-number]');
      console.log(`📊 Current grid has ${currentItems.length} items numbered from 1 to ${currentItems.length}`);

      if (targetItemNumber) {
        console.log(`🎯 Looking for target item #${targetItemNumber}...`);

        // Find the target item by data-item-number
        const targetItem = this.productsGrid.querySelector(`li[data-item-number="${targetItemNumber}"]`);

        if (targetItem) {
          // Scroll to the target item with some offset
          const offsetTop = targetItem.offsetTop - 100; // 100px offset from top

          window.scrollTo({
            top: offsetTop,
            behavior: 'smooth',
          });

          console.log(`✅ Successfully scrolled to item ${targetItemNumber} at position ${offsetTop}`);

          setTimeout(() => {
            targetItem.style.transform = '';
            targetItem.style.boxShadow = '';
            console.log('✨ Target item highlight removed');
          }, 1000);

          sessionStorage.removeItem(`Last Page Position URL: ${this.storageKey}`);
          return;
        } else {
          console.log(`❌ Target item ${targetItemNumber} not found in ${currentItems.length} loaded items`);
          console.log(
            'Available item numbers:',
            Array.from(currentItems).map((item) => item.getAttribute('data-item-number'))
          );
        }
      }

      // Fallback to scroll position if item not found
      if (fallbackScrollPosition) {
        window.scrollTo({
          top: fallbackScrollPosition,
          behavior: 'smooth',
        });

        console.log(`📍 Used fallback scroll to position ${fallbackScrollPosition}`);
      } else {
        console.log('⚠️ No target item or fallback position available');
      }
    }

    loadNextPage() {
      this.loading.classList.remove('dn');
      this.currentPage++;

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const products = html.querySelector('#product-grid');
          const infinite = html.querySelector('infinite-scroll');

          if (products && products.innerHTML.trim().length) {
            // Get the current number of items to continue numbering from
            const existingItems = this.productsGrid.querySelectorAll('li[data-item-number]');
            const lastItemNumber =
              existingItems.length > 0
                ? parseInt(existingItems[existingItems.length - 1].getAttribute('data-item-number'))
                : 0;

            // Update line item numbers for new items before adding to DOM
            const newItems = products.querySelectorAll('li[data-item-number]');
            newItems.forEach((item, index) => {
              const newItemNumber = lastItemNumber + index + 1;
              item.setAttribute('data-item-number', newItemNumber);
            });

            // Add the updated items to the grid
            this.productsGrid.insertAdjacentHTML('beforeend', products.innerHTML);
          }

          if (infinite) {
            this.dataset.url = infinite.dataset.url;
            this.dataset.currentPage = this.currentPage;
          } else {
            this.dataset.lastPage = true;
            this.observer.unobserve(this);
            if (this.seo) this.seo.classList.remove('o-0', 'h-0', 'pointer-none', 'overflow-hidden');
          }
          this.loading.classList.add('dn');
        })
        .catch((e) => {
          this.loading.classList.add('dn');
          console.error(e);
        });
    }
  }
  customElements.define('infinite-scroll', InfiniteScroll);

  } catch(e) { console.error(e); }
})();
})();
